module.exports = __webpack_public_path__ + "img/30.ba0b628b.jpg";